var ProductBar = class extends HTMLElement {
  constructor() {
    super();

    this.initHeadroom();

    this.inputs = this.querySelectorAll('input');
    this.inputs.forEach(input => {
      input.addEventListener('click', this.syncForm.bind(this));
    });

    this.addToCart = this.querySelector('.add-to-cart');
    this.addToCart.addEventListener('click', this.handleAddToCart.bind(this));

    this.mobileDropdowns = this.querySelectorAll('.open-dropdown');
    this.mobileDropdowns.forEach(dropdown => {
      dropdown.addEventListener('click', this.handleMobileDropdowns.bind(this));
    });

    this.productForm = document.querySelector('variant-radios');
  }

  initHeadroom() {
    let productBarOffset = window.pageYOffset + document.querySelector('.product-form__submit').getBoundingClientRect().top;
    if (window.outerWidth < 768) {
      if (productBarOffset > window.innerHeight) {
        productBarOffset = productBarOffset - window.innerHeight;
      } else {
        productBarOffset = -1;
      }
    }
    const productHeadroom = new Headroom(document.querySelector('.product-bar-wrapper'), { offset: productBarOffset });
    productHeadroom.init();
  }

  syncFromForm(form) {
    form.querySelectorAll('input:checked').forEach(input => {
      this.querySelector('input:checked').removeAttribute('checked');
      this.querySelector(`input[value="${input.value}"]`).checked = true;
    });
  }

  syncForm(event) {
    this.querySelectorAll('input:checked').forEach(input => {
      this.productForm.querySelector(`input[value="${input.value}"]`).click();
    });

    this.productForm.setActiveValues(event.currentTarget);
    this.closeAllMobileDropdowns();
  }

  handleAddToCart() {
    document.querySelector('.product-form__submit').click();

    // Trigger form change
    let event = new Event('change');
    document.querySelector('.product-form form').dispatchEvent(event);
  }

  handleMobileDropdowns(event) {
    event.preventDefault();
    const dropdownButton = event.currentTarget;
    const dropdown = dropdownButton.nextElementSibling;

    if (dropdownButton.classList.contains('active')) {
      dropdownButton.classList.remove('active');
      dropdown.classList.add('opacity-0', 'invisible');
    } else {
      dropdownButton.classList.add('active');
      dropdown.classList.remove('opacity-0', 'invisible');
    }
  }

  closeAllMobileDropdowns() {
    this.querySelectorAll('.open-dropdown.active').forEach(button => {
      button.classList.remove('active');
    });

    this.querySelectorAll('.dropdown').forEach(dropdown => {
      if (!dropdown.classList.contains('opacity-0')) {
        dropdown.classList.add('opacity-0', 'invisible');
      }
    });
  }
}

customElements.define('product-bar', ProductBar);